const t = ({ current: e }) => e ? e.ownerDocument.defaultView : null;
export {
  t as getContextWindow
};
